/* Verdea Bosque — interacciones. Un módulo por componente; cada uno sale si su elemento no existe. */
(function () {
  var sinMovimiento = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function iniciar() {
    initIluminar();
    initReveal();
    initParallax();
    initCarrusel();
    initFaq();
    initAnadir();
  }

  function initReveal() {
    var els = document.querySelectorAll('.vb-reveal');
    if (!els.length) return;
    if (sinMovimiento || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('vb-visible'); });
      return;
    }
    var obs = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (!e.isIntersecting) return;
        var retraso = Number(e.target.getAttribute('data-vb-delay') || 0);
        setTimeout(function () { e.target.classList.add('vb-visible'); }, retraso);
        obs.unobserve(e.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { obs.observe(el); });
  }

  /* Imagen de fondo que se desplaza más lento que la página */
  function initParallax() {
    var capas = Array.prototype.slice.call(document.querySelectorAll('[data-vb-parallax]'));
    capas = capas.filter(function (c) { return Number(c.getAttribute('data-vb-parallax')) > 0; });
    if (!capas.length || sinMovimiento) return;
    var pendiente = false;
    function actualizar() {
      pendiente = false;
      var alto = window.innerHeight;
      capas.forEach(function (capa) {
        var img = capa.querySelector('img');
        if (!img) return;
        var r = capa.getBoundingClientRect();
        if (r.bottom < 0 || r.top > alto) return;
        var intensidad = Number(capa.getAttribute('data-vb-parallax')) / 100;
        var progreso = (r.top + r.height / 2 - alto / 2) / (alto + r.height);
        img.style.transform = 'translate3d(0,' + (-progreso * intensidad * r.height - r.height * 0.075) + 'px,0)';
      });
    }
    window.addEventListener('scroll', function () {
      if (!pendiente) { pendiente = true; requestAnimationFrame(actualizar); }
    }, { passive: true });
    window.addEventListener('resize', actualizar);
    actualizar();
  }

  /* Frase grande: cada palabra se ilumina al avanzar el scroll */
  function initIluminar() {
    var frases = document.querySelectorAll('[data-vb-iluminar]');
    if (!frases.length || sinMovimiento) return;
    frases.forEach(function (frase) {
      envolverPalabras(frase);
      var palabras = frase.querySelectorAll('.vb-palabra');
      var pendiente = false;
      function actualizar() {
        pendiente = false;
        var r = frase.getBoundingClientRect();
        var alto = window.innerHeight;
        var progreso = (alto * 0.85 - r.top) / (r.height + alto * 0.35);
        progreso = Math.max(0, Math.min(1, progreso));
        var encendidas = Math.round(progreso * palabras.length);
        palabras.forEach(function (p, i) { p.classList.toggle('vb-encendida', i < encendidas); });
      }
      window.addEventListener('scroll', function () {
        if (!pendiente) { pendiente = true; requestAnimationFrame(actualizar); }
      }, { passive: true });
      actualizar();
    });
  }

  function envolverPalabras(nodo) {
    Array.prototype.slice.call(nodo.childNodes).forEach(function (hijo) {
      if (hijo.nodeType === 3) {
        var trozos = hijo.textContent.split(/(\s+)/);
        var frag = document.createDocumentFragment();
        trozos.forEach(function (t) {
          if (!t) return;
          if (/^\s+$/.test(t)) { frag.appendChild(document.createTextNode(t)); return; }
          var s = document.createElement('span');
          s.className = 'vb-palabra';
          s.textContent = t;
          frag.appendChild(s);
        });
        hijo.parentNode.replaceChild(frag, hijo);
      } else if (hijo.nodeType === 1 && hijo.tagName !== 'BR') {
        envolverPalabras(hijo);
      }
    });
  }

  function initCarrusel() {
    document.querySelectorAll('[data-vb-carrusel]').forEach(function (car) {
      var pista = car.querySelector('.vb-carrusel-pista');
      var tarjetas = Array.prototype.slice.call(car.querySelectorAll('.vb-carrusel-tarjeta'));
      var puntosWrap = car.querySelector('.vb-carrusel-puntos');
      if (!pista || tarjetas.length < 2) return;
      var intervaloMs = Number(car.getAttribute('data-vb-intervalo')) || 5000;
      var indice = 0;
      var puntos = [];

      function visibles() {
        var ancho = car.clientWidth;
        var t = tarjetas[0].getBoundingClientRect().width || ancho;
        return Math.max(1, Math.round(ancho / t));
      }
      function maximo() { return Math.max(0, tarjetas.length - visibles()); }
      function pintarPuntos() {
        if (!puntosWrap) return;
        puntosWrap.innerHTML = '';
        puntos = [];
        for (var i = 0; i <= maximo(); i++) {
          (function (n) {
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'vb-carrusel-punto';
            b.setAttribute('aria-label', 'Ir a la reseña ' + (n + 1));
            b.addEventListener('click', function () { ir(n); parar(); });
            puntosWrap.appendChild(b);
            puntos.push(b);
          })(i);
        }
      }
      function ir(i) {
        var max = maximo();
        indice = i > max ? 0 : (i < 0 ? max : i);
        pista.style.transform = 'translateX(-' + tarjetas[indice].offsetLeft + 'px)';
        puntos.forEach(function (p, n) { p.classList.toggle('vb-activo', n === indice); });
      }
      var reloj;
      function arrancar() { if (!sinMovimiento) { parar(); reloj = setInterval(function () { ir(indice + 1); }, intervaloMs); } }
      function parar() { clearInterval(reloj); }

      /* Deslizar con el dedo */
      var x0 = null;
      pista.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; parar(); }, { passive: true });
      pista.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) ir(indice + (dx < 0 ? 1 : -1));
        x0 = null;
      });
      car.addEventListener('mouseenter', parar);
      car.addEventListener('mouseleave', arrancar);
      window.addEventListener('resize', function () { pintarPuntos(); ir(Math.min(indice, maximo())); });
      pintarPuntos();
      ir(0);
      arrancar();
    });
  }

  function initFaq() {
    document.querySelectorAll('.vb-faq-item').forEach(function (item) {
      var boton = item.querySelector('.vb-faq-pregunta');
      var resp = item.querySelector('.vb-faq-respuesta');
      if (!boton || !resp) return;
      boton.addEventListener('click', function () {
        var abierto = item.classList.contains('vb-abierto');
        item.parentElement.querySelectorAll('.vb-faq-item.vb-abierto').forEach(function (otro) {
          if (otro === item) return;
          otro.classList.remove('vb-abierto');
          otro.querySelector('.vb-faq-respuesta').style.maxHeight = null;
          otro.querySelector('.vb-faq-pregunta').setAttribute('aria-expanded', 'false');
        });
        item.classList.toggle('vb-abierto', !abierto);
        resp.style.maxHeight = abierto ? null : resp.scrollHeight + 'px';
        boton.setAttribute('aria-expanded', String(!abierto));
      });
    });
  }

  /* Añadir al carrito desde las tarjetas sin salir de la página */
  function initAnadir() {
    document.querySelectorAll('[data-vb-anadir]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        if (!window.fetch) return;
        e.preventDefault();
        var boton = form.querySelector('button');
        var original = boton.textContent;
        boton.disabled = true;
        var raiz = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        fetch(raiz + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(form.querySelector('[name="id"]').value), quantity: 1 }], sections: 'cart-icon-bubble' })
        })
          .then(function (r) { if (!r.ok) throw new Error('carrito'); return r.json(); })
          .then(function (datos) {
            boton.textContent = boton.getAttribute('data-texto-ok') || 'Añadido';
            var burbuja = document.getElementById('cart-icon-bubble');
            if (burbuja && datos.sections && datos.sections['cart-icon-bubble']) {
              var tmp = document.createElement('div');
              tmp.innerHTML = datos.sections['cart-icon-bubble'];
              var nuevo = tmp.querySelector('.shopify-section') || tmp;
              burbuja.innerHTML = nuevo.innerHTML;
            }
            setTimeout(function () { boton.textContent = original; boton.disabled = false; }, 2200);
          })
          .catch(function () { form.submit(); });
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();
